import React from "react";
import { FRAMELESS_GRID_CELL_SIZE_M } from "../configuratorConstants";

const FrameRenderer = ({ frame, scale, isSelected, onClick }) => {
    const { x = 0, y = 0, width = 0, length = 0, rotation = 0, name, sandwichCountWidth, sandwichCountLength, svgUrl } = frame || {};
    
    const safeScale = scale || 1;
    const widthPx = width * safeScale;
    const lengthPx = length * safeScale;

    console.log('🖼️ [FrameRenderer Canvas] Rendering frame:', {
        frame,
        x,
        y,
        width,
        length,
        widthPx,
        lengthPx,
        scale: safeScale,
        svgUrl,
        name,
    });

    const transform = `translate(${x * safeScale}, ${y * safeScale}) rotate(${rotation || 0})`;

    return (
        <g
            transform={transform}
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) onClick(frame.id);
            }}
            className="cursor-pointer"
        >
            {/* SVG Image */}
            {svgUrl && (
                <image
                    href={svgUrl}
                    x={0}
                    y={0}
                    width={widthPx}
                    height={lengthPx}
                    preserveAspectRatio="none"
                />
            )}
            
            {/* Fallback if no SVG */}
            {!svgUrl && (
                <rect
                    x={0}
                    y={0}
                    width={widthPx}
                    height={lengthPx}
                    fill="rgba(243, 244, 246, 0.5)"
                    stroke={isSelected ? "#3b82f6" : "#9ca3af"}
                    strokeWidth={isSelected ? 2 : 1}
                    rx={2}
                />
            )}
        </g>
    );
};

export default FrameRenderer;
